import { trendingItems } from '@/mocks/homeData';

export default function TrendingSection() {
  return (
    <section id="trending" className="bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4">
          <div className="max-w-xl">
            <p className="text-xs font-medium text-primary-700 tracking-wide flex items-center gap-2">
              <span className="w-6 h-px bg-primary-300"></span>
              搜索热度数据
            </p>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              大家都在搜什么
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              围绕吃瓜捷克的高频检索词热度榜。看大家都在关心「身份、年龄、资料」，
              而真正想了解的人，最后都会落到「账号」与「动态」上。
            </p>
          </div>
          <div className="inline-flex items-center gap-2 text-xs text-foreground-500 bg-background-50 border border-background-200 rounded-full px-3 py-1.5 w-fit whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
            近 30 日数据 · 已脱敏
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-1">
          {trendingItems.map((t) => (
            <div
              key={t.keyword}
              className="group py-3 border-b border-background-200 last:border-b-0 flex items-center gap-4"
            >
              <span
                className={`w-7 h-7 shrink-0 rounded-md flex items-center justify-center text-xs font-medium ${
                  t.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                }`}
              >
                {t.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-900 truncate">{t.keyword}</span>
                  <span
                    className={`inline-flex items-center gap-0.5 text-[11px] whitespace-nowrap ${
                      t.delta === '上升' ? 'text-accent-700' : 'text-foreground-400'
                    }`}
                  >
                    <i className={t.delta === '上升' ? 'ri-arrow-up-line' : 'ri-arrow-right-line'} aria-hidden="true"></i>
                    {t.delta}
                  </span>
                </div>
                <div className="mt-1.5 h-1.5 rounded-full bg-background-200 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-primary-400 to-accent-500"
                    style={{ width: `${t.heat}%` }}
                  ></div>
                </div>
              </div>
              <span className="text-xs text-foreground-400 tabular-nums w-10 text-right shrink-0">{t.heat}</span>
            </div>
          ))}
        </div>

        <p className="mt-5 text-xs text-foreground-400 flex items-center gap-1.5">
          <i className="ri-bar-chart-2-line" aria-hidden="true"></i>
          热度为相对参考值，代表检索热度占比，不代表真实流量或任何运营数据。
        </p>
      </div>
    </section>
  );
}